export enum ROUTE {
  DASHBOARD = 'dashboard',
  PROFILE = 'profile',
  CHANGELOGS = 'changelogs',
  CHANGELOG = 'changelog',
  CURRENCIES = 'currencies',
  USERS = 'users',
  GAMES = 'games',
  TAGS = 'tags',
  GAME_NEW = 'game_new',
  GAME_EDIT = 'game_edit',
  GAME_LAUNCH_URL = 'game_launch_url',
  GAME_OF_WEEK = 'game_of_week',
  GAME_OF_WEEK_LIST = 'game_of_week_list',
  GAME_OF_WEEK_NEW = 'game_of_week_new',
  GAME_OF_WEEK_EDIT = 'game_of_week_edit',
  GAME_CATEGORIES_WRAP = 'game_categories_wrap',
  GAME_CATEGORIES = 'game_categories',
  PROVIDER_MANAGEMENT = 'provider_management',
  PROVIDER_GAMES_LOGS = 'provider_games_logs',
  API_KEYS = 'api_keys',
  NEW_API_KEY = 'new_api_key',
  PROVIDER_GAME_SESSION = 'provider_games_session',
  PROVIDERS_FEES = 'providers_fees',
  PROVIDERS_DISCOUNTS = 'providers_discounts',
  COMMENTS_UNPUBLISHED = 'comments_unpublished',
  COMMENTS_PUBLISHED = 'comments_published',
  COMMENTS_SPAM = 'comments_spam',
  COMMENTS_COMPLAINTS = 'comments_complaints',
  COMMENTS_EDIT = 'comments_edit',
  COMPLAINTS_EDIT = 'complaints_edit',
  COMMENTS_SETTINGS = 'comments_settings',
  COLLECTIONS = 'collections',
  COLLECTION_NEW = 'collection_new',
  COLLECTION_EDIT = 'collection_edit',
  SETTINGS_TENANT = 'settings_tenant',
  HOT_COLD = 'hot_cold',
  ERR_404 = '404',
  ERR_500 = '500',
}
